let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gxjpT")).then(() => parcelRequire('g7f5D'));